import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=631cbbdd&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=631cbbdd&prod&lang=css"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=631cbbdd&prod&lang=css"
import style2 from "./sidebar.vue?vue&type=style&index=2&id=631cbbdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cbbdd",
  null
  
)

export default component.exports